import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Tooltip } from "@material-ui/core";
import { ExampleCell, ExampleTable } from "./styled";

function Example() {
  const { t } = useTranslation("accounts");

  return (
    <ExampleTable>
      <thead>
        <tr>
          <ExampleCell>{t("email")}</ExampleCell>
          <ExampleCell>
            {t("column.alias")}
            <Box fontSize=".8rem" fontWeight="300">
              ({t("bulk.spaceSeparated")})
            </Box>
          </ExampleCell>
          <ExampleCell>{t("column.boxAccount", { value: "Box" })}</ExampleCell>
          <ExampleCell>
            {t("column.oneDriveAccount", { value: "OneDrive" })}
          </ExampleCell>
          <ExampleCell>
            {t("column.googleDriveAccount", { value: "Google Drive" })}
          </ExampleCell>
          <ExampleCell>
            {t("column.dropboxAccount", { value: "Dropbox" })}
          </ExampleCell>
          <ExampleCell>
            {t("column.tags")}
            <Box fontSize=".8rem" fontWeight="300">
              ({t("bulk.spaceSeparated")})
            </Box>
          </ExampleCell>

          <Tooltip title={t("column.approvalGroupsHint")} aria-label="hint">
            <ExampleCell>
              {t("column.approvalGroups")}
              <Box fontSize=".8rem" fontWeight="300">
                {t("column.approvalGroupsInfo")} <b>(*)</b>
              </Box>
            </ExampleCell>
          </Tooltip>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>john@test.com</td>
          <td />
          <td />
          <td />
          <td />
          <td />
          <td />
          <td />
        </tr>
      </tbody>
    </ExampleTable>
  );
}

export default React.memo(Example);
